"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectSpread"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _objectDestructuringEmpty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectDestructuringEmpty"));

var _react = _interopRequireWildcard(require("react"));

var _Box = _interopRequireDefault(require("../Box"));

var _HorizontalStack = _interopRequireDefault(require("../HorizontalStack"));

var _ = require("..");

var _InputRaw = _interopRequireDefault(require("../InputRaw"));

var __jsx = _react["default"].createElement;
var defaults = {
  rootCss: function rootCss(_ref2) {
    var focused = _ref2.focused;
    return {
      position: "relative",
      display: "flex",
      verticalAlign: "top",
      overflow: "hidden",
      flexDirection: "row",
      cursor: "text"
    };
  },
  $input: function $input(_ref3) {
    (0, _objectDestructuringEmpty2["default"])(_ref3);
    return {
      __type: _InputRaw["default"],
      height: "100%",
      width: "100%"
    };
  },
  $leftEnhancersContainer: function $leftEnhancersContainer(_ref4) {
    var leftEnhancer = _ref4.leftEnhancer;
    return {
      __type: _HorizontalStack["default"],
      height: "100%",
      flexGrow: 0,
      flexShrink: 0,
      pointerEvents: "none",
      __children: leftEnhancer
    };
  },
  $rightEnhancersContainer: function $rightEnhancersContainer(_ref5) {
    var rightEnhancer = _ref5.rightEnhancer;
    return {
      __type: _HorizontalStack["default"],
      height: "100%",
      flexGrow: 0,
      flexShrink: 0,
      pointerEvents: "none",
      __children: rightEnhancer
    };
  },
  $controlContainer: function $controlContainer(_ref6) {
    var control = _ref6.control,
        label = _ref6.label,
        arrow = _ref6.arrow,
        cursor = _ref6.cursor;
    return {
      position: "relative",
      boxSizing: "border-box",
      height: "100%",
      flexGrow: 1,
      flexShrink: 1,
      display: "flex",
      alignItems: "center",
      cursor: cursor,
      // pointerEvents: "none",
      __children: (0, _.jsx)(_react["default"].Fragment, null, label, control, arrow)
    };
  },
  $label: function $label(_ref7) {
    var label = _ref7.label,
        empty = _ref7.empty;
    return {
      __type: "span",
      position: "absolute",
      pointerEvents: "none",
      top: 0,
      left: 0,
      opacity: empty ? 0 : 1,
      __children: label
    };
  },
  $arrowContainer: function $arrowContainer(_ref8) {
    var arrow = _ref8.arrow;
    return {
      position: "absolute",
      top: 0,
      right: 0,
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      pointerEvents: "none",
      __children: arrow,
      __props: {
        key: "arrow"
      }
    };
  },
  $arrow: {
    __children: (0, _.jsx)(_react["default"].Fragment, null, "\u2304")
  }
};

function InputContainer$(props) {
  var sx = props.sx,
      _onFocus = props.onFocus,
      _onBlur = props.onBlur,
      _onClick = props.onClick,
      autoFocus = props.autoFocus,
      controlRef = props.controlRef,
      invalid = props.invalid,
      disabled = props.disabled,
      placeholder = props.placeholder,
      leftEnhancer = props.leftEnhancer,
      rightEnhancer = props.rightEnhancer,
      label = props.label,
      children = props.children,
      _props$forceFocused = props.forceFocused,
      forceFocused = _props$forceFocused === void 0 ? false : _props$forceFocused,
      rootRef = props.rootRef,
      _ref = props._ref,
      _props$cursor = props.cursor,
      cursor = _props$cursor === void 0 ? "default" : _props$cursor,
      _props$empty = props.empty,
      empty = _props$empty === void 0 ? true : _props$empty,
      _props$showArrow = props.showArrow,
      showArrow = _props$showArrow === void 0 ? false : _props$showArrow,
      _props$clearable = props.clearable,
      clearable = _props$clearable === void 0 ? false : _props$clearable,
      onClear = props.onClear,
      inputProps = (0, _objectWithoutProperties2["default"])(props, ["sx", "onFocus", "onBlur", "onClick", "autoFocus", "controlRef", "invalid", "disabled", "placeholder", "leftEnhancer", "rightEnhancer", "label", "children", "forceFocused", "rootRef", "_ref", "cursor", "empty", "showArrow", "clearable", "onClear"]);

  var _useState = (0, _react.useState)(false),
      focused = _useState[0],
      setFocused = _useState[1];

  focused = focused || forceFocused; // let [empty, setEmpty] = useState(true);
  //
  // if (props.value) {
  //     empty = props.value === "";
  // }

  var internalControlRef = (0, _react.useRef)(null);
  controlRef = controlRef || internalControlRef;
  var state = {
    focused: focused,
    invalid: invalid,
    disabled: disabled,
    empty: empty,
    placeholder: placeholder
  };
  sx = typeof sx === "function" ? sx(state) : sx;

  var _splitSx = (0, _.splitSx)(sx),
      _splitSx2 = (0, _slicedToArray2["default"])(_splitSx, 2),
      css = _splitSx2[0],
      customSx = _splitSx2[1];

  if (customSx.$labelInside) {
    state.label = label || placeholder || "Label";
  }

  var rootCss = typeof customSx.$root === "function" ? customSx.$root(state) : customSx.$root;

  var controlRaw = _react["default"].Children.only(children);

  var controlCss = typeof customSx.$control === "function" ? customSx.$control(state) : customSx.$control;
  (0, _react.useEffect)(function () {
    if (autoFocus && controlRef.current.focus) {
      controlRef.current.focus();
    }
  }, []);

  var control = _react["default"].cloneElement(controlRaw, (0, _objectSpread2["default"])({
    onFocus: function onFocus(e) {
      setFocused(true);

      if (_onFocus) {
        _onFocus(e);
      }
    },
    onBlur: function onBlur(e) {
      setFocused(false);

      if (_onBlur) {
        _onBlur(e);
      }
    },
    disabled: disabled,
    placeholder: placeholder
  }, inputProps, {
    sx: (0, _objectSpread2["default"])({}, controlCss, controlRaw.props.sx),
    _ref: controlRef,
    noFocus: true
  }));

  var inputContainer;
  var inputContainerState = (0, _objectSpread2["default"])({}, state, {
    control: control
  });
  var arrowContainer;

  if (showArrow) {
    var arrow = (0, _.createElement)((0, _.getElementSpec)(customSx.$arrow, defaults.$arrow, state));
    arrowContainer = (0, _.createElement)((0, _.getElementSpec)(customSx.$arrowContainer, defaults.$arrowContainer, (0, _objectSpread2["default"])({}, state, {
      arrow: arrow
    })));
  }

  if (showArrow === "inline") {
    inputContainerState.arrow = arrowContainer;
    arrowContainer = null;
  }

  if (sx.$labelInside) {
    inputContainerState.label = (0, _.createElement)((0, _.getElementSpec)(customSx.$label, defaults.$label, state));
  }

  inputContainerState.cursor = cursor;
  inputContainer = (0, _.createElement)((0, _.getElementSpec)(customSx.$controlContainer, (0, _objectSpread2["default"])({}, defaults.$controlContainer(inputContainerState), {
    __type: sx.$labelInside ? "label" : "div"
  }), inputContainerState));
  leftEnhancer = typeof leftEnhancer === "function" ? leftEnhancer(state) : leftEnhancer;
  var leftEnhancersContainerSpec = (0, _.getElementSpec)(customSx.$leftEnhancersContainer, defaults.$leftEnhancersContainer, (0, _objectSpread2["default"])({}, state, {
    leftEnhancer: leftEnhancer
  }));
  var leftEnhancerContainer = leftEnhancer && (0, _.createElement)(leftEnhancersContainerSpec);
  rightEnhancer = typeof rightEnhancer === "function" ? rightEnhancer(state) : rightEnhancer;
  var rightEnhancer2 = (0, _isArray["default"])(rightEnhancer) ? rightEnhancer : rightEnhancer ? [rightEnhancer] : [];

  if (showArrow === "enhancer") {
    rightEnhancer2.unshift(arrowContainer);
  }

  if (clearable && !empty) {
    rightEnhancer2.unshift((0, _.jsx)(_Box["default"], {
      sx: {
        pointerEvents: "auto",
        cursor: "pointer"
      },
      onClick: function onClick(e) {
        onClear();
      }
    }, customSx.$clearElement || "X"));
  }

  var rightEnhancersContainerSpec = (0, _.getElementSpec)(customSx.$rightEnhancersContainer, defaults.$rightEnhancersContainer, (0, _objectSpread2["default"])({}, state, {
    rightEnhancer: rightEnhancer2
  }));
  var rightEnhancerContainer = rightEnhancer2.length > 0 && (0, _.createElement)(rightEnhancersContainerSpec);
  return (0, _.jsx)(_Box["default"], {
    sx: [defaults.rootCss(state), {
      cursor: cursor
    }, rootCss, css],
    _ref: _ref || rootRef // TODO: rootRef is legacy, can be removed later
    ,
    onClick: function onClick() {
      if (_onClick) {
        _onClick.apply(void 0, arguments);
      } // console.log('on open');


      controlRef.current.focus();
    }
  }, leftEnhancerContainer, inputContainer, rightEnhancerContainer);
}

var _default = InputContainer$;
exports["default"] = _default;